// extracted by mini-css-extract-plugin
module.exports = {"contactIcon":"ContactIcon_contactIcon__B99Uk","icon":"ContactIcon_icon__2G1G5","text":"ContactIcon_text__1Qv5O","emailTooltip":"ContactIcon_emailTooltip__1uPpZ"};